import { render, staticRenderFns } from "./jtbianji.vue?vue&type=template&id=3c364e4c&scoped=true&"
import script from "./jtbianji.vue?vue&type=script&lang=js&"
export * from "./jtbianji.vue?vue&type=script&lang=js&"
import style0 from "./jtbianji.vue?vue&type=style&index=0&id=3c364e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c364e4c",
  null
  
)

export default component.exports